import { css, createTheme } from '@mui/material/styles';
import { colors } from '../styles/colors.js';
import { greenBorder, redBorder } from '../styles/sharedCss.js';
import shippoTheme$1 from '../styles/shippoTheme.js';

const textFieldThemeInput = {
    palette: {
        text: {
            primary: colors.text.primary.black,
        },
        primary: {
            main: colors.secondary,
            dark: colors.secondary,
        },
    },
    components: {
        MuiTextField: {
            styleOverrides: {
                root: css `
          & label {
            color: ${colors.text.default};

            &.MuiInputLabel-root {
              &:not(.Mui-focused) {
                color: ${colors.text.secondary};
              }

              &.Mui-disabled {
                color: ${colors.secondaryDisabled};
              }

              &:not(.MuiInputLabel-shrink) {
                /* This defaults to 9px Y. We added 8px to the height: 4px top and 4px bottom. We adjst Y by 4 px. */
                transform: translate(14px, 13px) scale(1);
                -webkit-transform: translate(14px, 13px) scale(1)
                -moz-transform: translate(14px, 13px) scale(1);
              }
            }

            &.MuiInputLabel-shrink {
              color: ${colors.text.default};

              &.Mui-error {
                color: ${colors.accent.foreground.error} !important;
              }
            }
          }

          & .MuiInputBase-input {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            min-height: 31px;

            &::placeholder {
              -webkit-text-fill-color: ${colors.text.secondary};
              color: ${colors.text.secondary};
              opacity: 1;
            }

            &:disabled {
              color: ${colors.secondaryDisabled};
              -webkit-text-fill-color: ${colors.secondaryDisabled};

              &::placeholder {
                color: ${colors.secondaryDisabled};
                -webkit-text-fill-color: ${colors.secondaryDisabled};
              }
            }
          }

          & .MuiInputBase-inputMultiline {
            margin-top: 4px;
            margin-bottom: 4px;
            text-wrap: wrap;
          }

          & .MuiOutlinedInput-root {
            border-radius: 8px;

            & .MuiSelect-select {
              min-height: 31px;
              line-height: 30px
            }

            fieldset {
              border-color: ${colors.borders};
            }
            
            &:hover fieldset {
              border-color: ${colors.borders};
            }

            &.Mui-focused fieldset {
              ${greenBorder}
            }

            &.Mui-error {
              &:not(.Mui-disabled) {
                &:hover {
                  fieldset {
                    border-color: ${colors.accent.foreground.error};
                  }
                }
              }

              &.Mui-focused fieldset {
                ${redBorder}
              }
            }
          }

          & .MuiInputBase-root.Mui-disabled {
            background: ${colors.secondaryHover};
            border-color: ${colors.borders};

            & .MuiOutlinedInput-notchedOutline {
              border-color: ${colors.borders};
            }
          }

          & .MuiFormHelperText-root {
            color: ${colors.secondary};

            &.Mui-error {
              color: ${colors.accent.foreground.error};
            }
          }
        `,
            },
        },
    },
};
var shippoTheme = createTheme(shippoTheme$1, textFieldThemeInput);

export { shippoTheme as default, textFieldThemeInput };
//# sourceMappingURL=TextField.theme.js.map
